
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slugOrId]",
      function () {
        return require("private-next-pages/blog/[slugOrId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[slugOrId]"])
      });
    }
  